<template lang="pug">
  lightbox(
    ref="lightbox"
    :images="imagesList"
    :showLightBox="showLightBox"
    :show-caption="showCaption")
</template>

<script>
import Lightbox from 'vue-image-lightbox'
export default {
  name: 'LightBox',
  components: {
    Lightbox
  },
  props: {
    lightBoxImgs: {
      type: Array,
      default: []
    },
    startAt: {
      type: Number,
      default: 0
    },
    showLightBox: {
      type: Boolean,
      default: true
    },
    showThumbs: {
      type: Boolean,
      default: true
    },
    autoPlay: {
      type: Boolean,
      default: false
    },
    autoPlayTime: {
      type: Number,
      default: 300
    },
    showCaption: {
      type: Boolean,
      default: false
    },
    imageDesc: {
      type: String,
      default: 'Hello World'
    }
  },
  computed: {
    imagesList () {
      return this.lightBoxImgs.map(res => {
        return {
          thumb: res,
          src: res,
          caption: `<h4>${this.imageDesc}</h4>`
        }
      })
    }
  },
  methods: {
    openGallery (index) {
      this.$refs.lightbox.showImage(index)
    },
    closeLightBox () {
      console.info('close:::::')
      // this.$emit('closeLightBox', data)
    }
  }
}
</script>



// WEBPACK FOOTER //
// index.vue?bd68c660